function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import Flex from '../Flex';
import Input from './Input';
import Suffix from './Suffix';
const PercentInput = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    field,
    ...props
  } = _ref;
  const onChange = props.onChange || field.onChange;
  const handleChange = React.useCallback(evt => !isNaN(evt.target.value) && onChange(evt), [onChange]);
  return /*#__PURE__*/React.createElement(Flex, {
    ref: ref
  }, /*#__PURE__*/React.createElement(Input, _extends({}, field, props, {
    onChange: handleChange,
    inputMode: "decimal",
    hasSuffix: true
  })), /*#__PURE__*/React.createElement(Suffix, {
    px: 3
  }, "%"));
});
PercentInput.propTypes = {};
PercentInput.defaultProps = {};
PercentInput.displayName = 'PercentInput';
export default PercentInput;